export const ACCESS_TOKEN_NAME = 'access';
export const LANG_NAME = 'lang';
export const REFRESH_TOKEN_NAME = 'refresh';
export const JSON_CONTENT_TYPE = 'application/json';
export const FORM_DATA_CONTENT_TYPE = 'form-data';
export const WARNING_DATA_CONTENT_TYPE = 'warning-data';
export const API_REQUEST_TIMEOUT_MILLISECONDS = 500_000;
export const API_REQUEST_TIMEOUT_MILLISECONDS_ERROR_STATUS = -10;
export const API_STATUS_PROBLEM =
  'Произошла ошибка, это все что мы знаем... Попробуйте повторить запрос позже';
export const SECRET_KEY_ADMIN = 'nurlat';

export const WINDOW_V = 0;
export const WINDOW_H = 1;

export const DESCTOP_CHANGE = 960;
export const DESCTOP_TWO_CHANGE = 1250;
export const DESCTOP_TWO_BUTTON_CHANGE = 1450;

export const TG_CHANAL = 'https://t.me/uchimed_chan';
export const VK_CHANAL = 'https://vk.com/learn_anat';
export const OFERTA_URL = 'https://xn--d1abiq7aya.xn--p1ai/api/offer.html';
export const POL_SOGL_URL = 'https://xn--d1abiq7aya.xn--p1ai/api/useragr.html';
export const SOGL_OBR_URL = 'https://xn--d1abiq7aya.xn--p1ai/api/persdata.html';
export const POLIT_CONFID_URL =
  'https://xn--d1abiq7aya.xn--p1ai/api/confid.html';
export const APPLE_SHOP = 'https://apps.apple.com/ru/app/учи-анат/id1530684725';
export const ANDROID_SHOP =
  'https://play.google.com/store/apps/details?id=com.learnanat';
export const HUAWEI_SHOP =
  'https://appgallery.cloud.huawei.com/ag/n/app/C109705735';

// export const TG_SUPPORT = 'https://t.me/uchi_med';
export const TG_SUPPORT = 'tg://resolve?domain=uchi_med';

// export const TG_SUPPORT_PURCAHSE = 'https://t.me/uchi_med_bot?start=';
export const TG_SUPPORT_PURCAHSE = 'tg://resolve?domain=uchi_med_bot&start=';

export const MAX_SUPPORT =
  'https://max.ru/u/f9LHodD0cOKKAbD2FplXO2w1XWd6P2DZ4DBaw7Eykex-F2QkXQObVgTeUEE';
export const MAX_SUPPORT_PURCAHSE = 'https://max.ru/id1655488623_bot?start=';

export const VK_SUPPORT = 'https://vk.me/learn_anat';
export const VK_SUPPORT_PURCAHSE = 'https://vk.me/learn_anat';
